import DPUDailyUse from '@elem/compPage/DPUDailyUse';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';

// 投广告专用
export default function Page() {
    const { useEffect, useRouter } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const theme = 'black';
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    useEffect(() => {
        if (!['us'].includes(locale)) {
            return router.push('/404');
        }
    }, []);

    return (
        <>
            <GtmPageLoad />
            <PageLayout hideToTop className={`${css.productcontent} ${theme} product_common product_common_real`} theme={theme}>
                <DPUDailyUse theme={theme} />
            </PageLayout>
            <style global jsx>
                {`
                    .ef-top-offers {
                        display: none;
                    }
                `}
            </style>
        </>
    );
}
